import update from "immutability-helper";
import {
  PROJECT_DETAILS_ADD_POINT_NOTE,
  PROJECT_DETAILS_ADD_STAGE,
  PROJECT_DETAILS_EDIT_STAGE_DATA,
  PROJECT_DETAILS_ERROR,
  PROJECT_DETAILS_FETCHING_DATA,
  PROJECT_DETAILS_GET_POINT_DATA,
  PROJECT_DETAILS_GET_POINT_NOTES,
  PROJECT_DETAILS_GET_STAGE_DATA,
  PROJECT_DETAILS_REMOVE_STAGE,
  PROJECT_DETAILS_STAGE_ADD_POINT,
  PROJECT_DETAILS_STAGE_REMOVE_POINT,
  PROJECT_DETAILS_STAGE_UPDATE_POINT,
  PROJECT_DETAILS_STAGE_UPLOAD_CSV,
  PROJECT_DETAILS_TOGGLE_POINT_SELECT,
  PROJECT_DETAILS_UNSET_POINT_DATA,
} from "../../typesAction";

const INITIAL_STATE = {
  project_id: null,
  stages: [],
  inProgress: true,
  errorMessage: null,
  selected_point_id: null,
  pointData: {},
  pointNotes: [],
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case PROJECT_DETAILS_GET_STAGE_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case PROJECT_DETAILS_EDIT_STAGE_DATA:
      const editedStage = action.payload;
      const stages = state.stages.map((el) => {
        if (el.id === editedStage.id) {
          return editedStage;
        }
        return el;
      });
      return {
        ...state,
        stages,
      };
    case PROJECT_DETAILS_ERROR:
      return {
        ...state,
        errorMessage: action.payload.data,
        inProgress: false,
      };
    case PROJECT_DETAILS_FETCHING_DATA:
      return {
        ...state,
        inProgress: action.payload,
        errorMessage: null,
      };
    case PROJECT_DETAILS_STAGE_UPDATE_POINT: {
      const stageIndex = state.stages.findIndex(
        (stage) => stage.id === action.payload.stage_id
      );
      if (stageIndex === -1) {
        return state;
      }

      const pointIndex = state.stages[stageIndex].geometries.findIndex(
        (point) => point.id === action.payload.point_id
      );
      if (pointIndex === -1) {
        return state;
      }

      const pointData = action.payload.pointData;
      if (!pointData) {
        return state;
      }

      const updatedStages = update(state.stages, {
        [stageIndex]: {
          geometries: {
            [pointIndex]: {
              $set: pointData,
            },
          },
        },
      });

      return { ...state, stages: updatedStages };
    }
    case PROJECT_DETAILS_STAGE_ADD_POINT: {
      const stageId = +action.payload.point.stage.split("/").pop();
      return {
        ...state,
        stages: state.stages.map((stage) => {
          if (stage.id === stageId) {
            return {
              ...stage,
              geometries: [...stage.geometries, action.payload.point],
            };
          }
          return stage;
        }),
      };
    }
    case PROJECT_DETAILS_STAGE_UPLOAD_CSV: {
      const stageId = +action.payload.processed[0].stage.split("/").pop();
      return {
        ...state,
        stages: state.stages.map((stage) => {
          if (stage.id === stageId) {
            return {
              ...stage,
              geometries: [...stage.geometries, ...action.payload.processed],
            };
          }
          return stage;
        }),
      };
    }
    case PROJECT_DETAILS_ADD_STAGE:
      return {
        ...state,
        stages: [...state.stages, action.payload],
      };
    case PROJECT_DETAILS_REMOVE_STAGE: {
      const stageIndex = state.stages.findIndex(
        (stage) => stage.id === action.payload.stage_id
      );
      if (stageIndex === -1) {
        return state;
      }
      return {
        ...state,
        stages: [
          ...state.stages.slice(0, stageIndex),
          ...state.stages.slice(stageIndex + 1),
        ],
      };
    }
    case PROJECT_DETAILS_STAGE_REMOVE_POINT: {
      const stageIndex = state.stages.findIndex(
        (stage) => stage.id === action.payload.stage_id
      );
      if (stageIndex === -1) {
        return state;
      }

      const pointIndex = state.stages[stageIndex].geometries.findIndex(
        (point) => point.id === action.payload.point_id
      );
      if (pointIndex === -1) {
        return state;
      }

      return {
        ...state,
        stages: [
          ...state.stages.slice(0, stageIndex),
          {
            ...state.stages[stageIndex],
            geometries: [
              ...state.stages[stageIndex].geometries.slice(0, pointIndex),
              ...state.stages[stageIndex].geometries.slice(pointIndex + 1),
            ],
          },
          ...state.stages.slice(stageIndex + 1),
        ],
      };
    }
    case PROJECT_DETAILS_TOGGLE_POINT_SELECT: {
      return {
        ...state,
        selected_point_id: action.payload.point_id,
      };
    }
    case PROJECT_DETAILS_GET_POINT_DATA: {
      return {
        ...state,
        pointData: action.payload.data,
      };
    }
    case PROJECT_DETAILS_GET_POINT_NOTES: {
      return {
        ...state,
        pointNotes: action.payload.data["hydra:member"],
      };
    }
    case PROJECT_DETAILS_ADD_POINT_NOTE: {
      return {
        ...state,
        pointNotes: [...state.pointNotes, action.payload.data],
      };
    }
    case PROJECT_DETAILS_UNSET_POINT_DATA: {
      return {
        ...state,
        selected_point_id: null,
        pointNotes: [],
        pointData: {},
      };
    }
    default:
      return state;
  }
}
